import { useState } from "react";
import { useUserpilot } from "@platform/hooks/useUserpilot";

import ConnectInfo from "@assets/images/connect_screen_info.svg";
import ConnectSkeleton from "@assets/images/connect_screen_skeleton.svg";
import RefreshLightIcon from "@assets/icons/refresh-light-icon.svg";

import { cn } from "@utils/tailwind.util";
import { BackgroundSection } from "@components/Sections";
import MainIcon from "@assets/images/main-icon.svg";
import { MainLogo } from "@ui/Logos/MainLogo";
import { Paragraph } from "@ui/Content";
import { Button } from "@ui/Button";
import { H3 } from "@ui/Headings";
import { loginWithMeridian } from "@platform/utils/chrome.util";
import ToastService from "@services/toast.service";
import { ERROR_STRINGS, ERROR_MESSAGES } from "@config/messages";
import { useBugsnagErrorHandler } from "@hooks/useBugsnagErrorHandler";

export default function LoginScreen() {
  const { track } = useUserpilot();
  const { notifyBugsnag } = useBugsnagErrorHandler();
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const connectMeridianAccount = async () => {
    track("Click: Login with Meridian");
    setIsLoggingIn(true);

    await loginWithMeridian().catch((error) => {
      setIsLoggingIn(false);
      notifyBugsnag(error, ERROR_STRINGS.LOGIN);
      ToastService.showUserError(ERROR_MESSAGES.LOGIN);
    });
  };

  return (
    <div className="flex flex-col">
      <div className="flex flex-col justify-center items-center pt-[100px] pb-[30px]">
        <MainLogo className="pb-[50px]" />

        <BackgroundSection
          className="bg-white"
          icon={
            <RefreshLightIcon
              width={16}
              height={16}
              className={cn("stroke-[1.76]", isLoggingIn && "animate-slowpin-reverse")}
            />
          }
          largeIcon={<MainIcon width={40} height={40} className="z-[4]" />}
          leftImage={<ConnectSkeleton className="w-[108px] rounded-xl" />}
          rightImage={<ConnectInfo className="w-[108px] rounded-xl" />}
          overlayPosition="bottom-right"
        />

        <div className="flex flex-col gap-3 my-[48px] px-4">
          <H3 className="text-[#406A68] font-bold">Log in to your Meridian account</H3>
          <Paragraph>
            To use Meridian in Gmail and Google Calendar, connect your Google account in the
            Meridian profile settings.
          </Paragraph>
        </div>

        <Button
          buttonType={"PRIMARY"}
          isDisabled={isLoggingIn}
          onClick={connectMeridianAccount}
          className="min-w-[270px]"
        >
          {isLoggingIn ? "Waiting for login…" : "Login with Meridian"}
        </Button>
      </div>
    </div>
  );
}
